import { CAMPAIGN_FORM_MESSAGES, CampaignFormMessages } from "./campaign-form.messages";
import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { GENDER_MESSAGES, GenderMessages } from "../gender/gender.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";

export type CampaignFormPageMessages = ActionButtonMessages &
  CampaignFormMessages &
  SidebarMessages &
  GenderMessages & {
    breadCrumbTitle: string;
    formPageTitle: string;
    createPageTitle: string;
    createCardTitle: string;
    campaignDataSection: string;
    contactsDataSection: string;
    productsDataSection: string;
    simpleMessageDataSection: string;
    exceptionLogsDataSection: string;

    imageUpdateError: string;
    imageCreateError: string;

    errorNoProductsForPromotionalPrice: string;

    noProductsAddedMessage: string;

    // Confirmation dialog messages
    noFiltersDialogTitle: string;
    noFiltersDialogDescription: string;
    noFiltersDialogCancel: string;
    noFiltersDialogConfirm: string;

    noProductsDialogTitle: string;
    noProductsDialogDescription: string;
    noProductsDialogCancel: string;
    noProductsDialogConfirm: string;

    // Simple Message Tab Messages
    simpleMessageLabel: string;
    simpleMessagePlaceholder: string;
    simpleMessageError: string;
    simpleMessageMaxLength: string;
    simpleMessageCharactersRemaining: string;
    simpleMessageClarityGuideline: string;
    addButtonLabel: string;
    buttonTextLabel: string;
    buttonTextPlaceholder: string;
    buttonTextError: string;
    buttonTextMaxLength: string;
    buttonLinkLabel: string;
    buttonLinkPlaceholder: string;
    buttonLinkError: string;
    buttonLinkInvalidError: string;
    buttonLinkOptionalGuideline: string;
    buttonLinkShortenerGuideline: string;
    variablesHelpText: string;
    noVariablesAvailable: string;
    globalVariablesTitle: string;
    customerFantasyLabel: string;
    customerCityLabel: string;
    customerFantasyVariable: string;
    customerCityVariable: string;
    contactNameVariable: string;
    contactCityVariable: string;

    // Error messages
    campaignNotFoundError: string;
    campaignNotFoundAlt: string;
  };

export const CAMPAIGN_FORM_PAGE_MESSAGES: CampaignFormPageMessages = {
  // Page titles
  breadCrumbTitle: "Campanhas",
  formPageTitle: "Detalhes da Campanha",
  createPageTitle: "Criar Campanha",
  createCardTitle: "Nova Campanha",

  // Section titles
  campaignDataSection: "Dados da Campanha",
  contactsDataSection: "Segmentação",
  productsDataSection: "Produtos",
  simpleMessageDataSection: "Mensagem da Campanha",
  exceptionLogsDataSection: "Logs de Execução",

  imageCreateError: "Erro ao criar a imagem do produto.",
  imageUpdateError: "Erro ao criar a imagem do produto.",

  errorNoProductsForPromotionalPrice:
    "A campanha do tipo Preço Promocional deve conter pelo menos um produto.",

  noProductsAddedMessage: "Nenhum produto foi adicionado a esta campanha.",

  // Confirmation dialog messages
  noFiltersDialogTitle: "Nenhum Filtro Informado",
  noFiltersDialogDescription:
    "Nenhum filtro informado, a campanha será enviada para todos os seus contatos. Deseja continuar?",
  noFiltersDialogCancel: "Não",
  noFiltersDialogConfirm: "Sim",

  noProductsDialogTitle: "Nenhum Produto Informado",
  noProductsDialogDescription:
    "Nenhum produto informado, a campanha será criada para todos os seus produtos. Deseja continuar?",
  noProductsDialogCancel: "Não",
  noProductsDialogConfirm: "Sim",

  // Simple Message Tab Messages
  simpleMessageLabel: "Mensagem com variáveis",
  simpleMessagePlaceholder: "Digite sua mensagem aqui...",
  simpleMessageError: "A mensagem é obrigatória",
  simpleMessageMaxLength: "A mensagem deve ter no máximo 1024 caracteres",
  simpleMessageCharactersRemaining: "caracteres restantes.",
  simpleMessageClarityGuideline:
    "Evite mensagens promocionais invasivas; mantenha o texto claro, contextual e sem erros gramaticais.",
  addButtonLabel: "Adicionar botão",
  buttonTextLabel: "Texto do botão",
  buttonTextPlaceholder: "Ex: Ver Oferta",
  buttonTextError: "O texto do botão é obrigatório quando o botão está habilitado",
  buttonTextMaxLength: "O texto do botão deve ter no máximo 20 caracteres",
  buttonLinkLabel: "Link do botão",
  buttonLinkPlaceholder: "Ex: https://talk2buy.com.br/oferta123",
  buttonLinkError: "O link do botão é obrigatório quando o botão está habilitado",
  buttonLinkInvalidError: "O link deve ser uma URL válida com protocolo http(s)",
  buttonLinkOptionalGuideline:
    "Deixe o link em branco para criar um botão de resposta (Reply). Informe uma URL para abrir um link externo.",
  variablesHelpText: "Variáveis disponíveis acima. Clique para inserir no texto como #variavel#.",
  buttonLinkShortenerGuideline: "Não use encurtadores de URL (ex.: bit.ly, tinyurl, t.co).",
  noVariablesAvailable: "Nenhuma variável disponível",
  globalVariablesTitle: "Variáveis Globais",
  customerFantasyLabel: "Nome da sua loja",
  customerCityLabel: "Cidade da sua loja",
  customerFantasyVariable: "CUSTOMER_FANTASY",
  customerCityVariable: "CUSTOMER_CITY",
  contactNameVariable: "NICKNAME",
  contactCityVariable: "CONTACT_CITY",

  // Error messages
  campaignNotFoundError: "Campanha não encontrada",
  campaignNotFoundAlt: "Campanha não encontrada",

  ...GENDER_MESSAGES,
  ...CAMPAIGN_FORM_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,
  ...SIDEBAR_MESSAGES,
};
